import type { ErrorEvent } from "@sentry/react";

export function isAbortLike(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  if (error.name === "AbortError") {
    return true;
  }
  if ("code" in error && error.code === "ECONNABORTED") {
    return true;
  }
  return /abort/i.test(`${error.name} ${error.message}`);
}

export function isClientHttpError(error: unknown): boolean {
  if (!(error instanceof Error) || error.name !== "ApiClientError") {
    return false;
  }
  const status =
    "response" in error
      ? (error as { response?: { status?: number } }).response?.status
      : undefined;
  return typeof status === "number" && status < 500;
}

/** Safari clipboard denial — UX toast handles it. */
export function isClipboardPermissionNoise(error: unknown): boolean {
  return error instanceof Error && error.name === "NotAllowedError";
}

export function redactAccessTokens(event: ErrorEvent): void {
  for (const crumb of event.breadcrumbs ?? []) {
    const url = crumb.data?.url;
    if (typeof url === "string" && crumb.data) {
      crumb.data.url = url.replace(
        /([?&]access_token=)[^&]+/gi,
        "$1[redacted]",
      );
    }
  }
}
